export default {
  skillSets: [],
  skillSet: undefined,
};
